import { FC } from 'react';
import { Box } from '@mui/material';
import { ViewTableRow } from './types';
import { ViewTableColumn } from './types';
import { StyledCell } from './ViewTableStyles';
import { ViewTableBackgroundColors, ViewTableValueColors } from './constants';

const ViewTableData: FC<{
  row: ViewTableRow;
  column: ViewTableColumn;
  index: number;
  fallback: string;
  isLastRow: boolean;
}> = ({ row, column, index, fallback, isLastRow }) => {
  const cell = row[column.key];
  const rawValue = cell?.value ?? fallback;
  const displayValue = cell?.valueConverter ? cell.valueConverter(rawValue) : rawValue;

  return (
    <StyledCell
      sx={{
        minWidth: index === 0 ? 120 : 100,
        fontWeight: cell?.bold || column.bold ? 700 : 400,
        color: cell?.color ? ViewTableValueColors[cell.color] : 'inherit',
        backgroundColor: cell?.background ? ViewTableBackgroundColors[cell.background] : 'inherit',
        ...(isLastRow && { borderBottom: 'none' }),
      }}
    >
      {cell?.startAdornment ? (
        <Box display="flex" alignItems="center">
          {cell.startAdornment}
          {displayValue}
        </Box>
      ) : (
        displayValue
      )}
    </StyledCell>
  );
};

export default ViewTableData;
